const CompanionAppUsageDateRange = {
  FromStartOfCurrentSchoolYear: 0,
  Last7Days: 1,
  Last30Days: 2,
  Last90Days: 3,
  CustomRange: 4
};

export default CompanionAppUsageDateRange;